import React from "react";

export const ShipmentFulfillmentDetailContext = React.createContext(null);

export const useShipmentFulfillmentDetailContext = () => {
  const context = React.useContext(ShipmentFulfillmentDetailContext);

  if (!context)
    throw new Error("Collection Detail Context not provided!");

  return context;
};
